import Vue from "vue";
const AuthImage = require('vue-auth-image');
 
Vue.use(AuthImage);